import React from "react";

export function WB_CustomPollSingleChoice({}) {
    return <div>
        WB_CustomPollSingleChoice
    </div>
}